import { Component, OnInit} from '@angular/core';
import { MeterService } from 'projects/pplus/src/lib/components/elements/meter/meter.service';

@Component({
  selector: 'app-selfview-meter-consumed',
  templateUrl: './selfview-meter-consumed.component.html',
  styleUrls: ['./selfview-meter-consumed.component.scss'],
  providers: [MeterService]
})
export class SelfviewMeterConsumedComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {
  }
}
